<template>
  <div id="content">
    <div v-if="newsData.title &&newsData.titleShow == 1">
      <div class="title">{{newsData.title}}</div>
      <div class="titlebtm"></div>
    </div>
    <div class="newsclassify" ref="scroll">
      <Row :gutter="60">
          <Col span="6" v-for="(news,index) in newsList" :key="index">
            <div class="headline font24">
              <span>{{news.title}}</span>
              <span class="more font14" v-if="newsData.moreShow == 1" @click="tonewsList()">更多<img style="height: 12px;margin-left: 2px;position: relative;top: 1px;" src="/static/images/more.png" alt=""></span>
            </div>
            <div class="newslist">
              <Row>
                <Col span="24" class="newsltem pointer" v-for="(item,i) in dataobj[news.id]" :key="i">
                    <p :title="item.firstTitle">
                      <a v-if="item.recordTypeStr == '外部报道'" :href="item.myLink" target="_blank">{{item.firstTitle}}</a>
                      <router-link v-else :to="{name:'newsDetail', query: {id:item.id}}">{{item.firstTitle}}</router-link>
                      </p>
                </Col>
              </Row>
            </div>
          </Col>
      </Row>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api.js'
  export default {
    name: 'eduNewsOne',
    props:{
      newsData:{
        type:Object,
        default:null
      }
    },
    data() {
      return {
        newsList: [],
        dataobj: {}
      }
    },
    filters:{
      resetImg(val, type){
        const value = val
        let url
        if (type === 'arr') {
            if (value && value.length > 0) {
              url = value[0].surfaceImg
            }
        } else {
            url = value.surfaceImg
        }
        url = url && url.includes('http') ? url : this.futureImgUrl + url
        return url
      }
    },
    mounted() {
      this.newsList = this.newsData.news;
      this.getAxtNewSourceList()
      window.addEventListener('scroll', this.handleScroll)
    },
    methods:{
      handleScroll() {
        const that = this;
        // this.$refs.scroll.getBoundingClientRect().y指的是当前元素的y轴的位置
        // window.innerHeight是当前浏览器窗口的可视高度
        if ((this.$refs.scroll.getBoundingClientRect().y) < window.innerHeight) {
          this.$refs.scroll.classList.add('fadeInLeftBig')
        } else {

        }
      },
      getAxtNewSourceList(){
        let websiteId = localStorage.getItem('websiteId');
        const that = this;
        const url = '/axt-mhcz/axtNewSource/getAxtNewSourceList';
        this.newsList.forEach(v=> {
          const params = {
             website_id:websiteId,
             // classify_id:v.dataNewsTypeId,
             // ids:v.dataNewsIds,
             cancel_publish:0,
           }
          if(v.dataType == 2){
            params.classify_id = v.dataNewsTypeId
            params.pageSize = v.dataSize
          }else if(v.dataType == 1) {
            params.ids = v.dataNewsIds
          }
           // console.log(params,"params")
           api.getListAPI(url, params).then(res => {
             if (res.data.message == 'success') {
               this.$set(this.dataobj, v.id, res.data.data.rows)
               // console.log(res.data.data,'wwwwww',this.newsList);
             }
           })
        })
      },
      tonewsList(){
        this.$router.push({path:'/newsList'})
        this.$nextTick(()=>{
          $("body").scrollTop(0);
        })
      }
    }
  }
</script>

<style scoped="scoped">
  #content {
    width: 1200px;
    margin-bottom: 40px;
  }
  .newsimgbox {
    margin-top: 45px;
    margin-bottom: 40px;
  }
  .newsimgbox .imgbox {
    border-radius: 10px;
    overflow: hidden;
    position: relative;
  }
  .newsimgbox .imgbox p {
    width: 100%;
    padding: 0 5%;
    position: absolute;
    left: 0;
    bottom: 10px;
    color: #fff;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: all .5s;
    z-index: 1;
  }
  .newsimgbox .fl {
    width: 600px;
  }
  .newsimgbox .fr {
    width: 580px;
    margin-left: 20px;
  }
  .newsimgbox .fr .imgbox {
    width: 280px;
    /* height: 155px; */
    float: left;
   margin-bottom: 21px;
   margin-right: 20px;
  }
  .newsimgbox .fr .imgbox:nth-of-type(2n+2){
    margin-right: 0;
  }
  .newsimgbox .imgbox img {
    width: 100%;
    padding: 0;
    margin: 0;
    float: left;
    transition: all .5s;
  }
  .newsimgbox .imgbox:hover img {
    transform: scale(1.1);
    transition: all .5s;
  }
  .newsimgbox .imgbox .mark {
    width: 100%;
    height: 50%;
    position: absolute;
    left: 0;
    bottom: 0;
    overflow: hidden;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  }
  .newsimgbox .fl .imgbox p {
    bottom: 30px;
    transition: all .5s;

  }
  .newsimgbox .imgbox:hover .mark {
    height: 100%;
    background: rgba(0,0,0,0.4);
  }
  .newsimgbox .fr .imgbox:hover p {
    bottom: 30%;
    white-space: normal;
    overflow: visible;
    text-overflow:inherit;
    transform: translateY(50%);
    transition: all .5s;

  }
  .newsclassify {
    padding: 20px 0;
  }
  @media screen and (min-width: 1920px) {
    #content {
      width: 87.5%;
    }
    .newsimgbox .fl {
      width: 828px;
    }
    .newsimgbox .fr {
      width: 808px;
    }
    .newsimgbox .fl .imgbox {
      width: 828px;
    }
    .newsimgbox .fr .imgbox {
      width: 393px;
      height: 221px;
      margin-bottom: 22px;
    }
  }

  .headline {
    text-align: left;
    line-height: 1.8;
    padding-bottom: 3px;
    border-bottom: 4px solid #3583FF;
    position: relative;
  }
  .headline .more {
    color: #3583FF;
    float: right;
    position: relative;
    top: 10px;
    font-weight: 500;
    cursor: pointer;
  }
  .newslist {
    margin-top: 15px;
  }
  .newsltem {
    width: 100%;
    height: 78px;
    background: #F8F9FB;
    border-radius: 10px;
    display: flex;
    line-height: 1.6;
    padding: 0 22px;
    text-align: left;
    margin-bottom:13px ;
    align-items: center;
  }
  .newsltem p a {
    color: #555;
    display: block;
  }
  .newsltem p {
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
  }
  .newsltem:hover {
    background-color: #E8F1FF;
  }
  .newsltem:hover p a {
    color: #3583FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/indexContent/eduNewsOneStyleOne.vue